import React from 'react'
import { TextBox, Label, CheckBox, Grid, GridBody, GridHeader, ControlCenter, NewButton, SaveButton, Button, AdvanceSearch, AdvanceSearchGrid, AdvanceSearchButton } from '../../../BASE/Components'

export function generateRouteDisplay(componentList) {

    const rows = componentList["gridOperations"].data || []
    const totalCount = rows.length

    return (
        <>
            <ControlCenter item={componentList["CONTROL_CENTER"]} >
                <div className="loading" id="spinner" style={{ display: "none" }}>Loading&#8230;</div>

                <div className="page-header-wrp">
                    <div className="title-breadcrumb-wrp">
                        <h1 className="">{componentList["CONTROL_CENTER"].label.schema.value}</h1>
                    </div>
                    <div className="row">
                        <div className="col-12 d-flex justify-content-end">
                            <ControlCenter item={componentList["CONTROL_CENTER"]} >
                                <AdvanceSearch item={componentList["CONTROL_CENTER"]} className="advance-search" >
                                    <AdvanceSearchGrid typeName="AdvanceSearchGrid" />
                                    <AdvanceSearchButton typeName="AdvanceSearchButton" text="OK" />
                                </AdvanceSearch>
                                <Button className="btn common-btn common-btn-erp btn-sm mr-2" item={componentList["buttonAdvanceSearch"]}>
                                    <i className="fas fa-search fa-lg"></i>
                                </Button>
                                <NewButton className="btn common-btn common-btn-erp btn-sm mr-2" item={componentList["buttonNew"]}>
                                    <i className="far fa-file fa-lg"></i>
                                </NewButton>
                                <SaveButton className="btn common-btn common-btn-erp btn-sm mr-2" item={componentList["buttonSave"]}>
                                    <i className="far fa-save fa-lg"></i>
                                </SaveButton>
                                <Button className="btn common-btn common-btn-erp btn-sm" item={componentList["buttonUndo"]}>
                                    <i className="fas fa-undo fa-lg"></i>
                                </Button>
                            </ControlCenter>
                        </div>
                    </div>
                </div>

                <div className="container-fluid custom-container-padding">

                    <div className="form-wrp background-white">
                        <div className="row">
                            <div className="col-12">
                                <TextBox item={componentList["inputId"]} />
                                <div className="form-row">
                                    <div className="form-group col-md-3">
                                        <Label item={componentList["inputRouteCode"].label} />
                                        <TextBox item={componentList["inputRouteCode"]} className="form-control form-control-sm" />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <Label item={componentList["inputDescription"].label} />
                                        <TextBox item={componentList["inputDescription"]} className="form-control form-control-sm" />
                                    </div>
                                    <div className="form-group col-md-3 d-flex align-items-end pb-2">
                                        <div className="custom-control custom-switch">
                                            <CheckBox item={componentList["inputActive"]} className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="inputActive">Active</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row pb-4">
                        <div className="col-12">
                            <div className='table-wrp background-white'>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5 className="mb-0">Route Operations</h5>
                                    <Button
                                        className="btn btn-primary btn-sm rounded-pill px-3 shadow-sm d-inline-flex align-items-center"
                                        style={{ gap: "6px", fontWeight: 500 }}
                                        item={componentList["buttonAddOperation"]}>
                                        <i className="fa fa-plus"></i> Add Operation
                                    </Button>
                                </div>
                                <Grid item={componentList["gridOperations"]}
                                    deleteButton={<i className="fa fa-trash"></i>}
                                    customButton={<i className="fa fa-plus"></i>}
                                    className="table table-responsive table-striped table-sm w-100 d-block d-md-table">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="master-table-wrp">
                                                <GridHeader typeName="GridHeader" columns={componentList["gridOperations"].columns} />
                                                <GridBody typeName="GridBody" rows={componentList["gridOperations"].data} />
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                {totalCount === 0 &&
                                    <div className="text-center py-4" style={{ color: '#adb5bd' }}>
                                        No operations added yet &mdash; click the <i className="fa fa-plus"></i> icon to add an operation row.
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </ControlCenter>
        </>
    )
}
